function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
import { replaceInArray } from '@rd-web-markets/shared/dist/util/arrayUtils/arrayUtils';
const api = buildService('/fundings/{id}/document', {
  only: ['delete']
}, {
  only: ['postFormData']
});
const fundingDocumentService = {
  useCreate: (setLoading, setFundings) => {
    const createFundingDocument = serviceMethods.usePostFormData({
      callback: useCallback(async _ref => {
        let {
          fundingId,
          formData
        } = _ref;
        const updatedFunding = await api.postFormData(fundingId, formData);
        setFundings(prevFundings => {
          return prevFundings.map(f => f.id === updatedFunding.id ? updatedFunding : f);
        });
        return updatedFunding;
      }, [setFundings]),
      setLoading
    });
    return [createFundingDocument];
  },
  useDelete: (setLoading, setFundings) => {
    const deleteFundingDocument = serviceMethods.useDelete({
      callback: useCallback(async _ref2 => {
        let {
          fundingId
        } = _ref2;
        await api.delete(fundingId);
        setFundings(prevFundings => {
          return prevFundings.map(f => {
            if (f.id === fundingId) {
              return _objectSpread(_objectSpread({}, f), {}, {
                document: null
              });
            }
            return f;
          });
        });
      }, [setFundings]),
      setLoading
    });
    return [deleteFundingDocument];
  }
};
fundingDocumentService.useCrud = (setLoading, setFundings) => {
  const [createFundingDocument] = fundingDocumentService.useCreate(setLoading, setFundings);
  const [deleteFundingDocument] = fundingDocumentService.useDelete(setLoading, setFundings);
  return {
    createFundingDocument,
    deleteFundingDocument
  };
};
export default fundingDocumentService;